// extracted by mini-css-extract-plugin
export var configurationSection = "_rc-0";